import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {ListingCategory, PersonaType} from '../classes/enums';
import {Observable} from 'rxjs';
import { CommunicationService } from '../services/communication.service';

@Injectable()
export class PersonaTypeResolver implements Resolve<PersonaType> {

  constructor(private communicationService: CommunicationService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PersonaType> | Promise<PersonaType> | PersonaType {
    if (route.params.personaType) {
      switch (route.params.personaType) {
        case 'my-first-home':
          return PersonaType.FIRST_TIME_BUYER_SINGLE;
        case 'our-first-home':
          return PersonaType.FIRST_TIME_BUYER_COUPLE;
        case 'our-next-home':
          return PersonaType.MOVING_UP;
        case 'our-right-sized-home':
          return PersonaType.EMPTY_NESTERS;
        case 'our-luxury-home':
          this.communicationService.setCurrentListingType(ListingCategory.LUXURY);
          return PersonaType.LUXURY;
        case 'our-multi-family-home':
          return PersonaType.MULTI_GENERATIONAL_FAMILY;
        default:
          return null;
      }
    }
    return null;
  }
}
